import { Outlet } from 'react-router-dom';

import { useOauthRedirect } from '@/components/AuthModal/hooks';
import PaymentBreakdownModal from '@/components/PaymentBreakdownModal';
import { useSaveGclid } from '@/hooks';

import NoIndexMeta from './NoIndexMeta';
import { useLayout } from './hooks';

function EmptyLayout({ preventIndexing }) {
	useLayout();
	useOauthRedirect();
	useSaveGclid();

	return (
		<>
			{preventIndexing && <NoIndexMeta />}
			<Outlet />
			<PaymentBreakdownModal />
		</>
	);
}

export default EmptyLayout;
